import { Component, OnInit, Input, TemplateRef, ViewChild, EventEmitter, Output } from '@angular/core';
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbModal,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { ESEService } from 'app/shared/ese.service';
import { UploadStateStyleEnum } from 'app/shared/upload-file/upload-file.enum';
import { UploadFileService } from 'app/shared/upload-file/upload-file.service';
import { UtilsService } from 'app/shared/utils.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { ActivatedRoute } from '@angular/router';
import { ESE_ENUM, ESE_FRAMEWORK_KEYS, ESE_MAP_KEYS } from 'app/shared/enums/ese.enum';
import { FileTypeEnum } from 'app/API.service';
import { ClientLambdaService } from 'app/shared/client-lambda.service';
import { ModalTemplateComponent } from 'app/shared/modal-template/modal-template.component';
import { DomainFrameworkService } from 'app/shared/domain-framework.service';
interface Step {
  num: string;
  title: string;
  active: boolean;
  completed: boolean;
}
@Component({
  selector: 'cygov-create-ese-from-template-modal',
  templateUrl: './create-ese-from-template-modal.component.html',
  styleUrls: ['./create-ese-from-template-modal.component.scss'],
  standalone: false,
})
export class CreateEseFromTemplateModalComponent implements OnInit {
  steps: Step[] = [
    { num: 'first', title: 'Download Questionnaire Template', active: true, completed: false },
    { num: 'second', title: 'Upload Questionnaire', active: false, completed: false },
    { num: 'third', title: 'Upload Preview', active: false, completed: false },
  ];

  currentStepIndex: number = 0;
  parsedQuestions: any[] = [];
  uploadResult = { cleared: 0, failed: 0, failedQuestions: [] };
  progress: number = 0;
  disableNextBtn: boolean = false;
  disableBackBtn: boolean = false;
  requiredInfo: { fileType: string } = { fileType: 'RISKS_FILE' };
  invalidFileData = false;
  uploadStateEnum = UploadStateStyleEnum;
  eventName: string = '';
  isShowDueDateCalendar: boolean = false;
  selectedDueDate: NgbDateStruct;
  eventDueDate: string;
  tomorrowDate: NgbDateStruct;
  questions: any = [];
  isEditMode: boolean = false;
  headerItemsESE: any = [];
  keysObject: any;
  entityId: any;
  initialErrorObject: { [key: string]: boolean };
  initialQuestionObject: any;
  validationErrors: { [rowIndex: number]: { [key: string]: boolean } } = {};
  selectedQuestion: any = [];
  closeModalInstance: any;
  isLoading: boolean = true;
  isDataValidated: boolean = false;
  failedRows: any = [];
  removeFields = [ESE_ENUM.TEMPLATE_FILE, 'originalIndex', 'isUploaderOpen', ESE_ENUM.TEMPLATE, 'isSelected'];
  disableDelete: boolean = true;
  templateFileName: string;
  @Input() entity: any;
  @Input() selectedVendors: any = [];
  @Input() currentUser: string = '';
  file: any = null;
  isFileProcessing: boolean = false;
  selectedVendorName: string = '';
  @ViewChild('eseCreateFromTemaplteAcknowledgementHeader')
  eseCreateFromTemaplteAcknowledgementHeader!: TemplateRef<any>;
  @ViewChild('eseCreateFromTemaplteAcknowledgementContent')
  eseCreateFromTemaplteAcknowledgementContent!: TemplateRef<any>;
  @ViewChild('eseCreateFromTemaplteAcknowledgementFooter')
  eseCreateFromTemaplteAcknowledgementFooter!: TemplateRef<any>;
  ngbModalOptionsNewAcknowledgement: NgbModalOptions = {
    size: 'sm',
    windowClass:
      'modal-template-cont confirmation-filter-popup-window ese-craete-from-template-acknowledgement-modal-window',
    backdropClass:
      'modal-template-cont-backdrop risk-popup-backdrop-modal ese-create-from-template-acknowledgement-modal-backdrop',
    backdrop: 'static',
    centered: true,
  };
  eseLambdaResponse: any = null;
  @Output() closeEvent = new EventEmitter<any>();

  constructor(
    public activeModal: NgbActiveModal,
    private toaster: ToastrService,
    private eseService: ESEService,
    private parserFormatter: NgbDateParserFormatter,
    private uploadService: UploadFileService,
    private route: ActivatedRoute,
    private clientLambdaService: ClientLambdaService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.uploadService.resetEverything();
    // reset the steps state
    this.updateSteps();
    this.headerItemsESE = this.eseService.headerItemsESE;
    this.entityId = UtilsService.getRouteParam(this.route.root.snapshot, 'entityId');
    this.initialErrorObject = this.eseService.initialErrorObject;
    this.initialQuestionObject = this.eseService.initialQuestionObject;
    this.keysObject = this.eseService.keysObject;
    this.headerItemsESE = this.eseService.headerItemsESE;
    this.eseService.entity = this.entity;
    this.eseService.selectedVendors = this.selectedVendors;
    this.eseService.currentUser = this.currentUser;
    this.uploadService.uploadProcessComplete.subscribe(processCompleted => {
      if (processCompleted) {
        this.isFileProcessing = false;
        this.currentStepIndex = this.currentStepIndex + 1;
        this.updateSteps();
        if (!this.failedRows.length) {
          this.steps[2].completed = true;
        }
        this.isLoading = false;
      }
    });
    this.uploadService.getFile().subscribe(file => {
      if (file) {
        this.file = file;
        this.onUpload(file);
      }
    });
  }
  closeModal() {
    this.questions = [];
    this.eseService.onSave(this.questions);
    this.activeModal.close();
    if (this.closeModalInstance) {
      this.closeModalInstance.close();
    }
    this.closeEvent.emit({ eseLambdaResponse: this.eseLambdaResponse });
    this.uploadService.resetEverything();
  }

  updateSteps() {
    this.steps.forEach((s, i) => {
      if (i !== this.currentStepIndex) {
        s.active = false;
        s.completed = s.completed || i < this.currentStepIndex ? true : false;
      } else {
        s.active = true;
        s.completed = s.completed ? true : false;
      }
    });
    this.disableNextBtn = this.currentStepIndex + 1 <= this.steps.length ? false : true;
  }
  moveToNextStep(): void {
    switch (this.currentStepIndex) {
      case 0: // From Download to Upload
        this.disableNextBtn = true;
        break;

      case 1:
        this.isLoading = true;
        this.questions = [];
        this.isFileProcessing = this.file ? true : false;
        // If user didn't upload the file then alert him and don't move to next step
        if (!this.file) {
          return;
        }
        // If user upload the file and file is in processing
        if (this.isFileProcessing) {
          return;
        }
        break;

      case 2:
        this.isLoading = false;
        this.isFileProcessing = false;
        break;
    }
    this.currentStepIndex = this.currentStepIndex + 1;
    this.updateSteps();
  }

  moveBackToOldStep(): void {
    this.currentStepIndex = this.currentStepIndex - 1;
    this.questions = [];
    this.uploadService.resetEverything();
    this.updateSteps();
  }

  selectedDueDateChangeFunc($event: any): void {
    this.selectedDueDate = $event;
    const dDate = new Date(this.parserFormatter.format(this.selectedDueDate));
    this.eventDueDate = `
    ${dDate.getMonth() + 1 < 10 ? '0' + (dDate.getMonth() + 1) : dDate.getMonth() + 1}.${
      dDate.getDate() < 10 ? '0' + dDate.getDate() : dDate.getDate()
    }.${dDate.getFullYear() % 100}`;
    setTimeout(() => {
      this.isShowDueDateCalendar = false;
    }, 1000);
  }
  /**
   * Handle XLSX file upload, convert it to JSON, and add to questions list
   */
  onUpload(file) {
    // TODO: here open modal for warning
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: 'array' });

      // Read second sheet (index 1) and convert to JSON
      const sheetName = workbook.SheetNames[1];
      const sheet = workbook.Sheets[sheetName];

      let jsonData: any[] = XLSX.utils.sheet_to_json(sheet, { defval: null });

      if (!jsonData.length) {
        this.toaster.info('Uploaded template is empty');
        return;
      }

      // Step 1: Remove empty header columns
      const allKeys = Object.keys(jsonData[0]).filter(key => key.trim() !== '');
      // Step2: Check all columns are in file

      const missingColumns = this.eseService.requiredColumns.filter(col => !allKeys.includes(col));
      if (missingColumns.length) {
        this.toaster.info(`The uploaded file is missing required column(s): ${missingColumns.join(', ')}`);
        return;
      }

      // Step 3: Remove columns that are empty (null) in all rows
      const nonEmptyColumns = allKeys.filter(key =>
        jsonData.some(row => this.eseService.requiredColumns.includes(key))
      );
      this.questions = [];
      // Step 4: Keep only non-empty columns
      jsonData = jsonData.map(row => {
        const cleanedRow: any = {};
        nonEmptyColumns.forEach(key => {
          cleanedRow[key] = row[key] != null ? row[key] : '';
        });
        return cleanedRow;
      });

      let newRowIndex = this.questions.length;
      this.enableEdit(true);

      jsonData.forEach(d => {
        // Assign question number
        d[this.keysObject.questionNumber] = newRowIndex + 1;

        // Normalize mandatoryArtifacts
        const mandatoryArtifacts = d[this.keysObject.mandatoryArtifacts];
        d[this.keysObject.mandatoryArtifacts] =
          mandatoryArtifacts === true || mandatoryArtifacts === false
            ? this.eseService.capitalizeFirstLetter(mandatoryArtifacts.toString())
            : this.eseService.capitalizeFirstLetter(mandatoryArtifacts || '');

        // Normalize mandatoryComments
        const mandatoryComments = d[this.keysObject.mandatoryComments];
        d[this.keysObject.mandatoryComments] =
          mandatoryComments === true || mandatoryComments === false
            ? this.eseService.capitalizeFirstLetter(mandatoryComments.toString())
            : this.eseService.capitalizeFirstLetter(mandatoryComments || '');

        this.validationErrors[newRowIndex] = JSON.parse(JSON.stringify(this.initialErrorObject));
        this.questions.push(d);
        newRowIndex++;
      });

      this.questions = JSON.parse(JSON.stringify(this.questions));
      this.questionDataValidation();
      this.eseService.onSave(this.questions);
    };

    reader.readAsArrayBuffer(file);
  }

  questionDataValidation() {
    this.failedRows = [];
    this.validationErrors = {};

    this.questions.forEach((row, rowIndex) => {
      this.isDataValidated = true;
      this.validationErrors[rowIndex] = {};
      let count = 0;
      Object.keys(row).forEach(key => {
        const isNotValid = this.columnValidation(rowIndex, key);
        count = isNotValid && !this.removeFields.includes(key) ? count + 1 : count;
      });
      this.isDataValidated = count === 0 ? true : false;
      if (!this.isDataValidated) {
        this.failedRows.push(rowIndex);
      } else {
        const index = this.failedRows.findIndex(r => r === rowIndex);
        if (index >= 0) this.failedRows.splice(index, 1);
      }
    });
  }

  /**
   * Validate a single cell in the questions table
   */
  columnValidation(rowIndex, key): boolean {
    const row = this.questions[rowIndex];
    const mandatoryComments = ['true', 'false'];
    const validValues = [null, undefined, ''];
    if (Object.keys(this.validationErrors).length) {
      let isEmpty = false;
      // Special case: check boolean values for specific fields
      if (key === ESE_ENUM.MANDATORY_ARTIFACTS || key === ESE_ENUM.MANDATORY_COMMENTS) {
        const value = row[key].toString();
        isEmpty = !mandatoryComments.includes(value.toLowerCase());
      } else {
        isEmpty = validValues.includes(row[key]);
      }
      this.validationErrors[rowIndex][key] = this.removeFields.includes(key) ? false : isEmpty;
      return isEmpty;
    }
  }

  checkSelectedRow() {
    const selectedRow = this.questions.filter(q => q.isSelected);
    return selectedRow.length ? false : true;
  }

  /**
   * Mark a row as selected based on checkbox interaction
   */
  setSelectedRow(event) {
    this.disableDelete = event.isChecked ? false : this.checkSelectedRow();
    this.questions[event.index].isSelected = event.isChecked;
  }

  /**
   * Handle inline question updates and validate
   */
  updateQuestion(event) {
    const { value, key, index } = event;
    this.questions[index][key] = value;
    // this.questionDataValidation();
  }

  /**
   * Deep copy the updated questions into local state
   */
  updateLocalState(questions) {
    this.questions = JSON.parse(JSON.stringify(questions));
  }

  removeIsSelected() {
    this.questions = this.questions.map(({ isSelected, ...rest }) => rest);
  }

  removeUnnecessaryFields(questions) {
    questions = questions.map(question => {
      const cleaned = { ...question };
      this.removeFields.forEach(field => {
        if (field !== ESE_ENUM.TEMPLATE) delete cleaned[field];
      });
      return cleaned;
    });
    return questions;
  }

  addQuestion() {
    this.removeIsSelected();
    this.isEditMode = true;

    const newRowIndex = this.questions.length;
    this.validationErrors[newRowIndex] = JSON.parse(JSON.stringify(this.initialErrorObject));

    const { questions } = this.eseService.addQuestion(this.questions);
    this.updateLocalState(questions);
  }
  onUploadArtifact(event: { file: File; rowIndex: number }): void {
    const { file, rowIndex } = event;
    // Ensure the object exists
    const question = this.questions[rowIndex];
    if (question[ESE_ENUM.TEMPLATE] === '' || !question[ESE_ENUM.TEMPLATE]) {
      question[ESE_ENUM.TEMPLATE] = 'ESE_ARTIFACT';
    }

    if (Array.isArray(question[ESE_ENUM.TEMPLATE_FILE])) {
      question[ESE_ENUM.TEMPLATE_FILE].push(file);
    } else {
      question[ESE_ENUM.TEMPLATE_FILE] = [file];
    }
  }

  removeArtifact(event) {
    const { questionIndex, fileIndex } = event;
    if (fileIndex !== null) {
      this.questions[questionIndex][this.keysObject.templateFile].splice(fileIndex, 1);
    } else {
      this.questions[questionIndex][this.keysObject.template] = '';
      this.questions[questionIndex][this.keysObject.templateFile] = [];
    }
  }
  /**
   * Validate entire questions array and collect any row errors
   */

  /**
   * Download existing questions template
   */
  async onDownload(): Promise<void> {
    await this.eseService.onDownload();
  }

  /**
   * Enable edit mode for questions
   */
  enableEdit(edit) {
    this.isEditMode = edit;
    // if Edit mode close so restore the state.
    if (!this.isEditMode) {
      this.questions = JSON.parse(JSON.stringify(this.eseService.cachedQuestions));
      this.questionDataValidation();
    }
  }

  /**
   * Delete selected rows from the question list
   */
  onDelete() {
    const selectedRow = this.questions.filter(q => q.isSelected);

    if (!selectedRow.length) {
      this.toaster.info('Please select at least one row');
      return;
    }

    selectedRow.forEach(s => {
      const index = this.questions.findIndex(
        q => s[this.keysObject.questionNumber] === q[this.keysObject.questionNumber]
      );
      if (index >= 0) this.questions.splice(index, 1);
      /** Update the failedRows  */
      if (this.failedRows.length && this.failedRows.includes(index)) {
        const f_index = this.failedRows.findIndex(i => i === index);
        this.failedRows.splice(f_index, 1);
      }
    });
    this.removeIsSelected();
    // Reassign question numbers based on new order
    this.questions.forEach((q, index) => {
      q[this.keysObject.questionNumber] = index + 1;
    });
    this.eseService.onSave(this.questions);
  }

  onSave() {
    this.questionDataValidation();
    if (!this.failedRows.length) {
      this.isEditMode = false;
      this.eseService.onSave(this.questions);
      this.questions = this.eseService.questions;
      this.steps[2].completed = true;
    } else {
      this.toaster.info('Missing required fields. Please complete marked fields to save.');
    }
  }

  checkEventNameAndDueDate() {
    if (this.questions.length && this.eseService.eventName && this.eseService.dueDate) {
      return true;
    }
    return false;
  }

  handleNextStep(): void {
    if (this.currentStepIndex === 2) {
      if (!this.isEditMode && this.checkEventNameAndDueDate() && !this.failedRows.length) {
        this.onComplete();
      }
    } else {
      this.moveToNextStep();
    }
  }

  shouldDisableNextStep(): boolean {
    const isDisable =
      this.disableNextBtn ||
      this.isEditMode ||
      (this.currentStepIndex === 2 && !this.checkEventNameAndDueDate()) ||
      this.failedRows.length > 0 ||
      this.currentStepIndex === 1;
    return isDisable;
  }

  transformObject() {
    return this.questions.map(obj => {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const newKey = ESE_MAP_KEYS[key] || key;
        acc[newKey] = value;
        return acc;
      }, {});
    });
  }

  async createFrameworkFromTemplate(formatedQuestionaire, assessmentIds, selectedVendors): Promise<void> {
    try {
      const vendorIds = selectedVendors.map(({ id }) => ({
        id,
      }));
      const payload = {
        assessmentIds,
        eventName: this.eseService.eventName,
        dueDate: this.eseService.dueDate,
        userId: this.currentUser,
        type: ESE_FRAMEWORK_KEYS.CUSTOM_RISK_FRAMEWORK,
        rootEntityId: this.entityId,
        vendorIds,
        questionaire: formatedQuestionaire,
      };
      const { Payload } = await this.clientLambdaService.invokeLambda(
        'createCustomFramework',
        payload,
        'RequestResponse'
      );

      const result = JSON.parse(Payload.transformToString());
      const body = JSON.parse(result.body).data;
      return body;
    } catch (err) {
      console.log('Error', err);
    }
  }

  /**
   * Complete the process if data is valid
   */
  async onComplete(): Promise<void> {
    let toastInterval;
    this.toaster.info('ESE framework creation is in Progress.');
    try {
      this.questionDataValidation();

      if (!this.failedRows.length) {
        toastInterval = setInterval(() => {
          this.toaster.info('Please wait it will take sometime to complete the process...', '', { timeOut: 1500 });
        }, 4000);
        this.disableNextBtn = true;
        await this.eseService.uploadArtifactTemplate(this.entityId, this.entity, this.questions);
        const formatedQuestionaire = this.transformObject();
        this.templateFileName = `${FileTypeEnum.ESE_TEMP}${Date.now()}.xlsx`;
        this.questions = this.removeUnnecessaryFields(JSON.parse(JSON.stringify(this.questions)));
        // await this.eseService.onComplete(this.entityId, this.entity, this.questions, this.templateFileName);
        let assessmentIds = this.selectedVendors.map(v => v.activeAssessmentId).filter(id => !!id);
        assessmentIds = [...new Set(assessmentIds)];
        const selectedVendors = [...new Map(this.selectedVendors.map(item => [item.id, item])).values()];
        this.eseLambdaResponse = await this.createFrameworkFromTemplate(
          formatedQuestionaire,
          assessmentIds,
          selectedVendors
        );
        this.sendEmailNotification(selectedVendors);
        this.openESECreateFromTempalteAcknowledgementModal(
          this.eseCreateFromTemaplteAcknowledgementHeader,
          this.eseCreateFromTemaplteAcknowledgementContent,
          this.eseCreateFromTemaplteAcknowledgementFooter
        );
      } else {
        this.toaster.info('Missing required fields. Please complete marked fields to save.');
      }
    } catch (err) {
      console.log('Error while Completing the process');
    } finally {
      // Stop repeating toast
      clearInterval(toastInterval);
    }
  }
  async sendEmailNotification(selectedVendors) {
    const result = selectedVendors.map(({ id, name, vendorDetails }) => ({
      id,
      name,
      email: vendorDetails?.primaryPoc?.email,
    }));
    const emailObject = {
      type: 'NOTIFY_VENDOR_EMERGING_SECURITY',
      vendors: result,
      rootId: this.entityId,
      eventName: this.eseService.eventName,
      domain: DomainFrameworkService.getDomain(),
    };
    await this.clientLambdaService.invokeLambda('sendNotification', emailObject);
  }
  openESECreateFromTempalteAcknowledgementModal(
    header: TemplateRef<any>,
    content: TemplateRef<any>,
    footer: TemplateRef<any>
  ) {
    const modalRef = this.modalService.open(ModalTemplateComponent, this.ngbModalOptionsNewAcknowledgement);
    const compInstance = modalRef.componentInstance;
    this.closeModalInstance = modalRef;

    this.eventName = this.eseService?.eventName;
    this.selectedVendorName = this.eseService.formatVendors(this.selectedVendors);

    compInstance.customizeHeader = true;
    compInstance.headerContentRef = header;
    compInstance.contentRef = content;
    compInstance.footerContentRef = footer;
    compInstance.closeEvent = this.closeEvent;
  }
  downLoadScreenView() {
    const temp_Questions = this.removeUnnecessaryFields(JSON.parse(JSON.stringify(this.questions)));
    this.eseService.downloadFile(temp_Questions);
  }

  get formattedFailedRows(): string {
    return this.eseService.formattedFailedRows(this.failedRows);
  }
}
